/*
| Developed by Dirupt
| Filename : MobileNavItem.tsx
| Author : Philippe DESPLATS (philippe@dirupt.com)
*/

import React from 'react';
import { Badge, BoxProps, Grid, styled } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import NextLink from 'next/link';
import { LinkProps } from 'next/dist/client/link';
import { useActiveLink } from '@/hooks/useActiveLink';
import { MOBILE_MEDIUM_PHONE, MOBILE_SMALL_PHONE, MOBILE_VERY_SMALL_PHONE, MobileNavLinkItem } from '@/components/layouts/app/DefaultLayout/MobileNav/MobileNav';

/*
|--------------------------------------------------------------------------
| Contracts
|--------------------------------------------------------------------------
*/
export type MobileNavItemProps = MobileNavLinkItem;

/*
|--------------------------------------------------------------------------
| Styles
|--------------------------------------------------------------------------
*/
const NavItem = styled(props => <Grid item {...props} />, {
  shouldForwardProp: propName => propName !== 'active'
})<BoxProps & {
  active: boolean;
}>(({
  theme,
  active
}) => ({
  position: 'relative',
  display: 'flex',
  flexDirection: 'row',
  alignItems: 'center',
  ...(active && {
    '&::before': {
      content: '""',
      position: 'absolute',
      top: 0,
      left: 0,
      right: 0,
      width: '100%',
      height: 3,
      borderRadius: 6,
      backgroundColor: theme.palette.primary.main
    }
  })
}));
const Link = styled(NextLink)<LinkProps>(() => ({
  width: MOBILE_VERY_SMALL_PHONE,
  height: MOBILE_VERY_SMALL_PHONE,
  '@media (min-width: 360px)': {
    width: MOBILE_SMALL_PHONE,
    height: MOBILE_SMALL_PHONE
  },
  '@media (min-width: 430px)': {
    width: MOBILE_MEDIUM_PHONE,
    height: MOBILE_MEDIUM_PHONE
  }
}));

/*
|--------------------------------------------------------------------------
| Component
|--------------------------------------------------------------------------
*/
export const MobileNavItem: React.FC<MobileNavItemProps> = ({
  icon,
  badge,
  href,
  activeBaseLink
}) => {
  const active = useActiveLink(activeBaseLink);
  const theme = useTheme();
  return <NavItem active={active} data-sentry-element="NavItem" data-sentry-component="MobileNavItem" data-sentry-source-file="MobileNavItem.tsx">
			<Link href={href} data-sentry-element="Link" data-sentry-source-file="MobileNavItem.tsx">
				<Badge invisible={!badge} badgeContent={badge} color={'primary'} data-sentry-element="Badge" data-sentry-source-file="MobileNavItem.tsx">
					{icon({
          fill: active ? theme.palette.primary.main : 'white'
        })}
				</Badge>
			</Link>
		</NavItem>;
};